import Vue from "vue";
import Router from "vue-router";
import store from "../store";
import { isCookieEnabled, getCookie } from "tiny-cookie";
import * as account from "../views/Account";
import * as customer from "../views/Customer";
import * as user from "../views/User";
import * as dashboard from "../views/DashBoard";
import * as documentation from "../views/Documentation";
import * as layout from "../views/Layout";
import * as service from "../views/Service";
import * as commingsoon from "../views/CommingSoon";
import * as property from "../views/Property";
import * as invoice from "../views/Invoice";
import * as report from "../views/Report";
import * as apartment from "../views/Apartment";
import * as advertise from "../views/Advertise";
import * as caseview from "../views/Case";
import * as pagenotfoundview from "../views/PageNotFound";
import * as projectview from "../views/Project";
import * as decentralization from "../views/Decentralization";
import * as search from "../views/Search";
import * as receipt from "../views/Receipt";
import * as mobile from "../views/Mobile";
import * as mailbox from "../views/Mailbox";
import * as userguest from "../views/UserGuest";
import * as banner from '../views/Banner'
import config from "../../build/config";
import * as notification from "../views/Notification";
import * as news from "../views/News"
import * as apartmentType from "../views/ApartmentType"
import * as product from "../views/Product"
import * as apartmentDiagram from "../views/ApartmentDiagram"
import * as apartmentBooking from "../views/ApartmentBooking"
import * as apartmentTypePrice from "../views/Configuration"
import * as homeMobileManagement from "../views/HomeMobileManagement"
import * as apartmentReceipt from "../views/ApartmentReceipt"
import * as eventManagement from "../views/Event"
import * as frequentlyAskedQuestions from "../views/FrequentlyAskedQuestions"
import * as apartmentGroup from "../views/ApartmentGroup"
Vue.use(Router);

const router = new Router({
  base: config.BASE_PATH,
  mode: "history",
  fallback: false,
  routes: [
    {
      path: "/",
      name: "DefaultLayout",
      redirect: "/dashboard",
      component: layout.DefaultLayout,
      children: [
        {
          path: "/no-project",
          component: pagenotfoundview.PageNoProject
        },
        {
          path: "/dashboard",
          name: "DashBoard",
          component: dashboard.DashBoard,
          meta: { requiresAuth: true }
        },
        {
          path: "/search",
          name: "Search",
          component: search.Search,
          meta: { requiresAuth: true }
        },
        {
          path: "/nopermission",
          name: "CommingSoon",
          component: commingsoon.CommingSoon,
          meta: { requiresAuth: true }
        },
        {
          path: "/mailbox",
          name: "MailboxRouter",
          redirect: "/sendmessage",
          component: mailbox.MailboxRouter,
          children: [
            {
              path: "compose",
              name: "ManagementCompose",
              component: mailbox.ManagementCompose,
              meta: { requiresAuth: true }
            },
            {
              path: "sendmessage",
              name: "ManagementMenu",
              component: mailbox.ManagementMenu,
              meta: { requiresAuth: true }
            },
            {
              path: "mailbox",
              name: "ManagementMailbox",
              component: mailbox.ManagementMailbox,
              meta: { requiresAuth: true }
            },
            {
              path: "detail/:id",
              name: "EmailFormAdd",
              component: mailbox.EmailFormAdd,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: "/customer",
          name: "Customer",
          redirect: "/customer/list",
          component: customer.Customer,
          children: [
            {
              path: "list",
              name: "CustomerList",
              component: customer.CustomerList,
              meta: { requiresAuth: true }
            },
            {
              path: "importExcel",
              name: "CustomerImportExcel",
              component: customer.CustomerImportExcel,
              meta: { requiresAuth: true }
            },
            {
              path: "givepoint",
              name: "CustomerGiveRewardPoint",
              component: customer.CustomerGiveRewardPoint,
              meta: { requiresAuth: true }
            },
            {
              path: "detail/:id",
              name: "CustomerAdd",
              component: customer.CustomerAdd,
              meta: { requiresAuth: true },
              children: [
                {
                  path: "service/history",
                  name: "ServiceHistory",
                  component: service.ServiceHistory,
                  meta: { requiresAuth: true }
                },
                {
                  path: "service/assigned",
                  name: "ServiceAssigned",
                  component: service.ServiceAssigned,
                  meta: { requiresAuth: true }
                },
                {
                  path: "service/serviceuserdetail/:serviceuserId",
                  name: "ServiceUserDetail",
                  component: service.ServiceUserDetail,
                  meta: { requiresAuth: true }
                }
              ]
            }
          ]
        },
        {
          path: "/userguest",
          name: "UserGuest",
          redirect: "/userguest/list",
          component: userguest.UserGuest,
          children: [
            {
              path: "list",
              name: "UserGuestList",
              component: userguest.UserGuestList,
              meta: { requiresAuth: true }
            },
            {
              path: "detail/:id",
              name: "UserGuestAdd",
              component: userguest.UserGuestAdd,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: "/company",
          name: "Company",
          redirect: "/company/list",
          component: customer.Customer,
          children: [
            // {
            //   path: "list",
            //   name: "CompanyList",
            //   component: customer.CompanyList,
            //   meta: { requiresAuth: true }
            // },
            {
              path: "list",
              name: "CompanyList",
              component: customer.CompanyList,
              meta: { requiresAuth: true }
            }
            // {
            //    path: "importExcel",
            //    name: "CompanyImportExcel",
            //    component: customer.CompanyImportExcel,
            //    meta: { requiresAuth: true }
            // },
          ]
        },
        {
          path: "/advertise",
          name: "Avertise",
          redirect: "advertise/list",
          component: advertise.Advertise,
          children: [
            {
              path: "list",
              name: "AdvertiseList",
              component: advertise.AdvertiseList,
              meta: { requiresAuth: true }
            },
            {
              path: "detail/:id",
              name: "AdvertiseAdd",
              component: advertise.AdvertiseAdd,
              meta: { requiresAuth: true }
            },
            {
              path: "advertiseprojectinfolist",
              name: "AdvertiseProjectInfoList",
              component: advertise.AdvertiseProjectInfoList,
              meta: { requiresAuth: true }
            },
            {
              path: "advertiseprojectinfoadd/detail/:id",
              name: "AdvertiseProjectInfoAdd",
              component: advertise.AdvertiseProjectInfoAdd,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: "/apartmentrealestate",
          name: "ApartmentRealestate",
          redirect: "apartmentrealestate/list",
          component: apartment.Apartment,
          children: [
            {
              path: "list",
              name: "ApartmentRealestateList",
              component: apartment.ApartmentRealestateList,
              meta: { requiresAuth: true }
            },
            {
              path: "detail/:id",
              name: "ApartmentRealestateAdd",
              component: apartment.ApartmentRealestateAdd,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: "/apartmentscheduleprogress",
          name: "ApartmentScheduleProgress",
          redirect: "apartmentscheduleprogress/list",
          component: apartment.Apartment,
          children: [
            {
              path: "list",
              name: "ApartmentScheduleProgressList",
              component: apartment.ApartmentScheduleProgressList,
              meta: { requiresAuth: true }
            },
            {
              path: "detail/:id",
              name: "ApartmentScheduleProgressAdd",
              component: apartment.ApartmentScheduleProgressAdd,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: "/apartmentcontract",
          name: "ApartmentContract",
          redirect: "apartmentcontract/list",
          component: apartment.Apartment,
          children: [
            {
              path: "list",
              name: "ApartmentContractList",
              component: apartment.ApartmentContractList,
              meta: { requiresAuth: true }
            },
            {
              path: "detail/:id",
              name: "ApartmentContractAdd",
              component: apartment.ApartmentContractAdd,
              meta: { requiresAuth: true }
            },
            {
              path: "apartmentcontractimportexcel",
              name: "ApartmentContractImportExcel",
              component: apartment.ApartmentContractImportExcel,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: "/apartment",
          name: "Apartment",
          redirect: "apartment/list",
          component: apartment.Apartment,
          children: [
            {
              path: "list",
              name: "ApartmentList",
              component: apartment.ApartmentList,
              meta: { requiresAuth: true }
            },
            {
              path: "detail/:id",
              name: "ApartmentAdd",
              component: apartment.ApartmentDetailTabs,
              meta: { requiresAuth: true },
              children: [
                {
                  path: "meterdevices",
                  name: "MeterDevices",
                  component: apartment.MeterDevices,
                  meta: { requiresAuth: true }
                }
              ]
            },
            {
              path: "leasebackapartmentdetail/:id",
              name: "LeaseBackApartmentDetail",
              component: apartment.LeaseBackApartmentDetail,
              meta: { requiresAuth: true },
              children: [
                {
                  path: "leasebackmeterdevices",
                  name: "LeaseBackMeterDevices",
                  component: apartment.MeterDevices,
                  meta: { requiresAuth: true }
                }
              ]
            },
            {
              path: "importExcel",
              name: "ApartmentImportExcel",
              component: apartment.ApartmentImportExcel,
              meta: { requiresAuth: true }
            },
            {
              path: "vehicle",
              name: "Vehicle",
              component: apartment.Vehicle,
              meta: { requiresAuth: true }
            },
            {
              path: "vehiclebikecar",
              name: "VehicleBikeCar",
              component: apartment.VehicleBikeCar,
              meta: { requiresAuth: true }
            },
            {
              path: "leasebackapartmentlist",
              name: "LeaseBackApartmentList",
              component: apartment.LeaseBackApartmentList,
              meta: { requiresAuth: true }
            },
            {
              path: "leasebackavailableapartmentlist",
              name: "LeaseBackAvailableApartmentList",
              component: apartment.LeaseBackAvailableApartmentList,
              meta: { requiresAuth: true }
            },
            {
              path: "leasebackavailableapartmentforgroup",
              name: "LeaseBackApartmentBookingForGroup",
              component: apartment.LeaseBackApartmentBookingForGroup,
              meta: { requiresAuth: true }
            },
            {
              path: "booking/:id",
              name: "LeaseBackApartmentBooking",
              component: apartment.LeaseBackApartmentBooking
            },
            {
              path: "reservation/list",
              name: "ApartmentReservationList",
              component: apartment.ApartmentReservationList,
              meta: { requiresAuth: true }
            },
            {
              path: "invoicegeneral/list",
              name: "InvoiceGeneralInvoiceList",
              component: apartment.InvoiceGeneralInvoiceList,
              meta: { requiresAuth: true }
            },
            {
              path: "invoicebookingpayment/list",
              name: "InvoiceBookingPaymentList",
              component: apartment.InvoiceBookingPaymentList,
              meta: { requiresAuth: true }
            },
            {
              path: "reservation/detail/:id",
              name: "LeaseBackBookingInfoView",
              component: apartment.LeaseBackBookingInfoView,
              meta: { requiresAuth: true }
            },
            {
              path: "leasebackcustomercompany/list",
              name: "LeaseBackCustomerCompanyList",
              component: apartment.LeaseBackCustomerCompanyList,
              meta: { requiresAuth: true }
            },
            {
              path: "leasebackresidentclient/list",
              name: "LeaseBackResidentClientList",
              component: apartment.LeaseBackResidentClientList,
              meta: { requiresAuth: true }
            },
            {
              path: "/leasebackstatisticsofbreakfastresidentclients",
              name: "LeaseBackStatisticsOfBreakfastResidentClients",
              component:
                apartment.LeaseBackStatisticsOfBreakfastResidentClients,
              meta: { requiresAuth: true }
            },
            {
              path: "roompolicy/list",
              name: "RoomPolicyList",
              component: apartment.RoomPolicyList,
              meta: { requiresAuth: true }
            },
            {
              path: "cleaningservice/list",
              name: "LeaseBackApartmentCleaningServiceManagement",
              component: apartment.LeaseBackApartmentCleaningServiceManagement,
              meta: { requiresAuth: true }
            },
            {
              path: "register-export-bill",
              name: "UserRegisterExportInvoice",
              component: invoice.UserRegisterExportInvoice,
              meta: { requiresAuth: true }
            },
            {
              path: "register-export-bill/detail/:id",
              name: "UserRegisterExportInvoiceAdd",
              component: invoice.UserRegisterExportInvoiceAdd,
              meta: { requiresAuth: true }
            },
            {
              path: "product-and-service",
              name: "ProductAndServiceInApartment",
              component: product.ProductAndServiceInApartment,
              meta: { requiresAuth: true }
            },
            {
              path: "apartment-booking",
              name: "ApartmentBookingList",
              component: apartmentBooking.ApartmentBookingList,
              meta: { requiresAuth: true }
            },
            {
              path: "apartment-booking-detail/:id",
              name: "ApartmentBookingDetail",
              component: apartmentBooking.ApartmentBookingDetail,
              meta: { requiresAuth: true }
            },
            {
              path: "room-bill",
              name: "RoomBill",
              component: apartmentBooking.RoomBill,
              meta: { requiresAuth: true }
            },
            {
              path: "approval-apartment-resident",
              name: "ApprovalApartmentResidentList",
              component: apartment.ApprovalApartmentResidentList,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: "/case",
          name: "Case",
          redirect: "case/list",
          component: caseview.Case,
          children: [
            {
              path: "list",
              name: "CaseList",
              component: caseview.CaseList,
              meta: { requiresAuth: true }
            },
            {
              path: "detail/:id",
              name: "CaseAdd",
              component: caseview.CaseAdd,
              meta: { requiresAuth: true }
            },
            {
              path: "escalationprocess",
              name: "EscalationProcess",
              component: caseview.EscalationProcess,
              meta: { requiresAuth: true }
            },
            {
              path: "escalationstage",
              name: "EscalationStage",
              component: caseview.EscalationStage,
              meta: { requiresAuth: true }
            },
            {
              path: "todolist",
              name: "TodoList",
              component: caseview.TodoList,
              meta: { requiresAuth: true }
            },
            {
              path: "emailformlist",
              name: "ManagementEmailFormList",
              component: mailbox.ManagementEmailFormList,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: "/invoice",
          name: "Invoice",
          redirect: "/invoice/list",
          component: invoice.Invoice,
          children: [
            {
              path: "list",
              name: "InvoiceList",
              component: invoice.InvoiceListV2,
              meta: { requiresAuth: true }
            },
            {
              path: "detail/:id",
              name: "InvoiceAdd",
              component: invoice.InvoiceAdd,
              meta: { requiresAuth: true }
            },
            {
              path: "receipt/list",
              name: "ReceiptList",
              component: receipt.ReceiptList,
              meta: { requiresAuth: true }
            },
            {
              path: "receipt/importExcel",
              name: "ReceiptImportExcel",
              component: receipt.ReceiptImportExcel,
              meta: { requiresAuth: true }
            },
            {
              path: "importExcel",
              name: "InvoiceImportExcel",
              component: invoice.InvoiceImportExcel,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: "/receipt",
          name: "Receipt",
          redirect: "/receipt/list",
          component: receipt.Receipt,
          children: [
            // {
            //   path: "list",
            //   name: "ReceiptList",
            //   component: receipt.ReceiptList,
            //   meta: { requiresAuth: true }
            // },
            {
              path: "detail/:id",
              name: "ReceiptAdd",
              component: receipt.ReceiptAdd,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: "/property",
          name: "Property",
          redirect: "/property/list",
          component: property.Property,
          children: [
            {
              path: "list",
              name: "PropertyList",
              component: property.PropertyList,
              meta: { requiresAuth: true }
            },
            {
              path: "detail/:id",
              name: "PropertyAdd",
              component: property.PropertyAdd,
              meta: { requiresAuth: true }
            },
            {
              path: "asset/list",
              name: "AssetList",
              component: property.AssetList,
              meta: { requiresAuth: true }
            },
            {
              path: "asset/detail/:id",
              name: "AssetAdd",
              component: property.AssetAdd,
              meta: { requiresAuth: true }
            },
            {
              path: "asset/importexcel",
              name: "AssetImportExcel",
              component: property.AssetImportExcel,
              meta: { requiresAuth: true }
            },
            {
              path: "asset/maintenance",
              name: "MaintenanceList",
              component: property.MaintenanceList,
              meta: { requiresAuth: true }
            },
            {
              path: "asset/maintenance/import-excel",
              name: "MaintenanceImportExcel",
              component: property.MaintenanceImportExcel,
              meta: { requiresAuth: true }
            },
            {
              path: "asset/activity-tracking/import-excel",
              name: "ImportActivityTracking",
              component: property.ImportActivityTracking,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: "/user",
          name: "User",
          redirect: "/user/list",
          component: user.User,
          children: [
            {
              path: "list",
              name: "UserList",
              component: user.UserList,
              meta: { requiresAuth: true }
            },
            {
              path: "detail/:id",
              name: "UserAdd",
              component: user.UserAdd,
              meta: { requiresAuth: true }
            },
            {
              path: ":id/decentralization",
              name: "DecentralizationUser",
              component: decentralization.DecentralizationUser,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: "/service",
          name: "Services",
          redirect: "/service/list",
          component: service.Service,
          children: [
            {
              path: "list",
              name: "ServiceList",
              component: service.ServiceTabs,
              meta: { requiresAuth: true }
            },
            {
              path: "detail/:id",
              name: "ServiceAddEdit",
              component: service.ServiceAddEdit,
              meta: { requiresAuth: true },
              children: [
                {
                  path: "usersbyservice",
                  name: "UsersByService",
                  component: service.UsersByService,
                  meta: { requiresAuth: true }
                }
              ]
            },
            {
              path: "package/list",
              name: "PackageList",
              component: service.PackageTemplateView,
              meta: { requiresAuth: true }
            },
            {
              path: "package/:id",
              name: "PackageDetails",
              component: service.PackageTemplateInputView,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: "/coupon",
          name: "Coupons",
          redirect: "/coupon/list",
          component: service.Coupons,
          children: [
            {
              path: "list",
              name: "ServiceCouponsManagement",
              component: service.ServiceCouponsManagement,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: "report",
          name: "Report",
          redirect: "/report/servicereport",
          component: report.Report,
          children: [
            {
              path: "liabilitiesreport",
              name: "LiabilitiesReport",
              component: report.LiabilitiesReport,
              meta: { requiresAuth: true }
            },
            {
              path: "accountinghomeliability",
              name: "AccountingHomeLiabilityList",
              component: report.AccountingHomeLiabilityList,
              meta: { requiresAuth: true }
            },
            {
              path: "reportaccountinghomeliability",
              name: "ReportAccountingHomeLiability",
              component: report.ReportAccountingHomeLiability,
              meta: { requiresAuth: true }
            },
            {
              path: "reportaccountinghomeliabilitydetail",
              name: "ReportAccountingHomeLiabilityDetail",
              component: report.ReportAccountingHomeLiabilityDetail,
              meta: { requiresAuth: true }
            },
            {
              path: "accountinghomeliabilityimportexcel",
              name: "AccountingHomeLiabilityImportExcel",
              component: report.AccountingHomeLiabilityImportExcel,
              meta: { requiresAuth: true }
            },
            {
              path: "room-performance-report",
              name: "RoomPerformanceReport",
              component: report.RoomPerformanceReport,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: "/project",
          name: "Project",
          redirect: "/project/detail/:id",
          component: projectview.Project,
          children: [
            {
              path: "addnew",
              name: "ProjectAddNew",
              component: projectview.ProjectAddNew,
              meta: { requiresAuth: true }
            },
            {
              path: "detail",
              name: "ProjectInfoView",
              component: projectview.ProjectInfoView,
              meta: { requiresAuth: true }
            },
            {
              path: "history",
              name: "ProjectHistory",
              component: projectview.HistoryTabs,
              meta: { requiresAuth: true }
            },
            {
              path: "mobile",
              name: "Mobile",
              component: mobile.MobileList,
              meta: { requiresAuth: true }
            },
            {
              path: "emailtemplate",
              name: "EmailTemplate",
              component: projectview.ProjectEmailTemplate,
              meta: { requiresAuth: true }
            },
            {
              path: "batchjoblist",
              name: "BatchJobList",
              component: projectview.BatchJobList,
              meta: { requiresAuth: true }
            },
            {
              path: "batchjoblist/detail/:id",
              name: "BatchJobAdd",
              component: projectview.BatchJobAdd,
              meta: { requiresAuth: true }
            },
            {
              path: "reward",
              name: "RewardPointManagement",
              component: projectview.RewardPointManagement,
              meta: { requiresAuth: true }
            },
            {
              path: "customizationtable_smtp",
              name: "CustomizationTable_SMTP",
              component: projectview.CustomizationTable_SMTP,
              meta: { requiresAuth: true }
            }
          ]
        },

        {
          path: "/documentation",
          name: "Documentation",
          redirect: "/documentation/list",
          component: documentation.Documentation,
          children: [
            {
              path: "list",
              name: "DocumentationList",
              component: documentation.DocumentationList,
              meta: { requiresAuth: true }
            },
            {
              path: "detail/:id",
              name: "DocumentationAdd",
              component: documentation.DocumentationAdd,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: "/decentralization",
          name: "Decentralization",
          redirect: "/decentralization",
          component: decentralization.Decentralization,
          children: [
            {
              path: "group",
              name: "DecentralizationGroup",
              component: decentralization.DecentralizationGroup,
              meta: { requiresAuth: true }
            },
            {
              path: "add/:id",
              name: "GroupAdd",
              component: commingsoon.CommingSoon,
              meta: { requiresAuth: true }
            }
          ]
        },
        // Banner
        {
          path: "/banner",
          name: "Banner",
          redirect: "/banner/list",
          component: banner.Banner,
          children: [
            {
              path: "list",
              name: "BannerList",
              component: banner.BannerList,
              meta: { requiresAuth: true }
            },
            {
              path: "add",
              name: "BannerAdd",
              component: banner.BannerAdd,
              meta: { requiresAuth: true }
            },
            {
              path: "update/:id",
              name: "BannerUpdate",
              component: banner.BannerAdd,
              meta: { requiresAuth: true }
            },
          ]
        },
        // News
        {
          path: "/news",
          name: "News",
          redirect: "/news/list",
          component: news.News,
          children: [
            {
              path: "residents/list",
              name: "ResidentsList",
              component: news.ResidentsList,
              meta: { requiresAuth: true }
            },
            {
              path: "list",
              name: "NewsList",
              component: news.NewsList,
              meta: { requiresAuth: true }
            },
            {
              path: "residents/add",
              name: "ResidentsAdd",
              component: news.ResidentsAdd,
              meta: { requiresAuth: true }
            },
            {
              path: "residents/update/:id",
              name: "ResidentsUpdate",
              component: news.ResidentsAdd,
              meta: { requiresAuth: true }
            },
            {
              path: "add",
              name: "NewsAdd",
              component: news.NewsAdd,
              meta: { requiresAuth: true }
            },
            {
              path: "update/:id",
              name: "NewsUpdate",
              component: news.NewsAdd,
              meta: { requiresAuth: true }
            },
            {
              path: "categories/list",
              name: "NewsCategoriesList",
              component: news.NewsCategoryList,
              meta: { requiresAuth: true }
            },
            {
              path: "categories/add",
              name: "NewsCategoriesAdd",
              component: news.NewsCategoryAdd,
              meta: { requiresAuth: true }
            },
            {
              path: "categories/update/:id",
              name: "NewsCategoriesUpdate",
              component: news.NewsCategoryAdd,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: "/config-template-notification",
          name: "ConfigTemplateNotification",
          redirect: "/config-template-notification",
          component: notification.Notification,
          children: [
            {
              path: "category",
              name: "NotificationCategory",
              component: notification.NotificationCategory,
              meta: { requiresAuth: true }
            },
            {
              path: "template-notification/:categoryId",
              name: "TemplateNotification",
              component: notification.TemplateNotification,
              meta: { requiresAuth: true }
            },
            {
              path: "template-notification-detail/:categoryId/:id",
              name: "TemplateNotificationDetail",
              component: notification.TemplateNotificationDetail,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: "/apartment-type",
          name: "ApartmentType",
          redirect: "/apartment-type/list",
          component: apartmentType.ApartmentType,
          children: [
            {
              path: "list",
              name: "ApartmentTypeAndApartmentGroup",
              component: apartmentType.ApartmentTypeAndApartmentGroup,
              meta: { requiresAuth: true }
            },
            // {
            //   path: "detail/:id",
            //   name: "ApartmentTypeAdd",
            //   component: apartmentType.ApartmentTypeAdd,
            //   meta: { requiresAuth: true }
            // }
          ]
        },
        {
          path: "/product",
          name: "Product",
          redirect: "/product/list",
          component: product.Product,
          children: [
            {
              path: "list",
              name: "ProductList",
              component: product.ProductTabs,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: "/apartment-diagram",
          name: "ApartmentDiagram",
          redirect: "/apartment-diagram/list",
          component: apartmentDiagram.ApartmentDiagram,
          children: [
            {
              path: "list",
              name: "ApartmentDiagramList",
              component: apartmentDiagram.ApartmentDiagramList,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: "/configuration-apartment-type-price",
          name: "ConfigurationApartmentTypePrice",
          redirect: "/configuration-apartment-type-price",
          component: apartmentTypePrice.Configuration,
          children: [
            {
              path: "apartment-type",
              name: "ApartmentTypeListWithPrice",
              component: apartmentTypePrice.ApartmentType,
              meta: { requiresAuth: true }
            },
            {
              path: "apartment-type-price/:apartmentTypeId",
              name: "ApartmentTypePriceList",
              component: apartmentTypePrice.ApartmentTypePrice,
              meta: { requiresAuth: true }
            },
            {
              path: "apartment-type-price-detail/:apartmentTypeId/:id",
              name: "ApartmentTypePriceAdd",
              component: apartmentTypePrice.ApartmentTypePriceAdd,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: "/home-mobile-management",
          name: "HomeMobileManagement",
          redirect: "/home-mobile-management",
          component: homeMobileManagement.HomeMobileManagement,
          children: [
            {
              path: "detail",
              name: "HomeMobileManagementAdd",
              component: homeMobileManagement.HomeMobileManagementAdd,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: "/management-service-order",
          name: "Service",
          redirect: "/management-service-order/list",
          component: service.Service,
          children: [
            {
              path: "list",
              name: "ManagementServiceOrder",
              component: service.ManagementServiceOrder,
              meta: { requiresAuth: true }
            },
            {
              path: "detail/:id",
              name: "ManagementServiceOrderDetail",
              component: service.ManagementServiceOrderDetail,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: "/apartment-receipt",
          name: "ApartmentReceipt",
          redirect: "/apartment-receipt/list",
          component: apartmentReceipt.ApartmentReceipt,
          children: [
            {
              path: "list",
              name: "ApartmentReceiptTabs",
              component: apartmentReceipt.ApartmentReceiptTabs,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: "/event-management",
          name: "EventManagement",
          redirect: "/event-management/list",
          component: eventManagement.Event,
          children: [
            {
              path: "list",
              name: "eventManagementList",
              component: eventManagement.EventList,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: "/frequently-asked-questions",
          name: "frequentlyAskedQuestions",
          redirect: "/frequently-asked-questions/list",
          component: frequentlyAskedQuestions.FrequentlyAskedQuestions,
          children: [
            {
              path: "list",
              name: "FrequentlyAskedQuestionsList",
              component: frequentlyAskedQuestions.FrequentlyAskedQuestionsList,
              meta: { requiresAuth: true }
            }
          ]
        },
        {
          path: "/apartment-group",
          name: "ApartmentGroup",
          redirect: "/apartment-group/list",
          component: apartmentGroup.ApartmentGroup,
          children: [
            {
              path: "list",
              name: "ApartmentGroupList",
              component: apartmentGroup.ApartmentGroupList,
              meta: { requiresAuth: true }
            }
          ]
        },
      ]
    },
    {
      path: "*",
      component: pagenotfoundview.PageNotFoundView
    },
    {
      path: "/account",
      name: "Account",
      redirect: "/account/login",
      component: account.Account,
      children: [
        {
          path: "login",
          name: "Login",
          component: account.Login
        },
        {
          path: "password_reset",
          name: "PasswordReset",
          component: account.PasswordReset
        },
        {
          path: "password_reset/done",
          name: "PasswordResetDone",
          component: account.PasswordResetDone
        },
        {
          path: "reset/:uidb64/:token",
          name: "PasswordResetSetPassword",
          component: account.PasswordResetSetPassword
        },
        {
          path: "email_activated/:uidb64/:token",
          name: "EmailActivated",
          component: account.EmailActivated
        }
      ]
    },
    {
      path: "/print-invoice-filter",
      name: "InvoicePdfFilter",
      component: invoice.InvoicePdfFilter,
      hidden: true
    },
    {
      path: "/print-receipt-filter",
      name: "ReceiptPdfFilter",
      component: receipt.ReceiptPdfFilter,
      hidden: true
    },
    {
      path: "/printproperty/:id",
      name: "PropertyPdf",
      component: property.PropertyPdf,
      hidden: true
    },
    {
      path: "/print-receipt-template-ck/:id",
      name: "ReceiptPdf_CK",
      component: receipt.ReceiptPdf_CK,
      hidden: true
    },
    {
      path: "/print-receipt-template-tm/:id",
      name: "ReceiptPdf_TM",
      component: receipt.ReceiptPdf_TM,
      hidden: true
    },
    {
      path: "/print-invoice-general-invoice-template-ck/:id",
      name: "InvoiceGeneralInvoicePdf_CK",
      component: apartment.InvoiceGeneralInvoicePdf_CK,
      props: { item: "xxxxxxxxxxxx" },
      hidden: true
    },
    {
      path: "/print-invoice-general-invoice-template-tm/:id",
      name: "InvoiceGeneralInvoicePdf_TM",
      component: apartment.InvoiceGeneralInvoicePdf_TM,
      hidden: true
    },
    {
      path: "/print-apartment-leaseback-clients/:id",
      name: "ApartmentLeasebackClientsPrintPdf",
      component: apartment.ApartmentLeasebackClientsPrintPdf,
      hidden: true
    },
    {
      path: "/resident-of-document/:id",
      name: "ResidentOfDocument",
      component: customer.ResidentOfDocument,
      hidden: true
    },
    {
      path: "/booking-confirmation-letter/:id",
      name: "ConfirmedApartmentBookingPdf",
      component: apartment.ConfirmedApartmentBookingPdf,
      hidden: true
    },
    {
      path: "/leasebackbookingpaymentpdf",
      name: "LeaseBackBookingPaymentPdf",
      component: apartment.LeaseBackBookingPaymentPdf,
      meta: { requiresAuth: true }
    },
    {
      path: "/booking-group-confirmation-letter/:id",
      name: "ConfirmedApartmentBookingGroupPdf",
      component: apartment.ConfirmedApartmentBookingGroupPdf,
      hidden: true
    },
    {
      path: "/print-asset-qr-code",
      name: "PrintQRCodeAsset",
      component: property.PrintQRCodeAsset,
      hidden: true
    },
    {
      path: "/print-maintenance/:id",
      name: "PrintMaintenance",
      component: property.PrintMaintenance,
      meta: { requiresAuth: true }
    }
  ],
  linkActiveClass: "active"
});

const isLogged = () =>
  store.getters.IS_AUTHENTICATED || loadSessionFromCookie();

const isAuthorizedRole = authRole => {
  let userRole;
  if (store.getters.GET_ACCOUNT_DATA.id) {
    userRole = store.getters.GET_ACCOUNT_DATA.group_id;
  } else {
    userRole = loadRoleFromCookie();
  }
  if (userRole && userRole <= authRole) {
    return true;
  }
  return false;
};

// const loadSessionFromLocalStorage = () => {
//   // if localstorage has token
//   //   commit a mutation for loggedIn and then return true
//   // else return false
// };

const loadSessionFromCookie = () => {
  const token = isCookieEnabled() ? getCookie("id_token") : "";
  if (token) {
    store.commit("SET_TOKEN", token);
    return true;
  } else {
    return false;
  }
};

const loadRoleFromCookie = () => {
  const role = isCookieEnabled() ? getCookie("role") : "";
  if (role) {
    return role;
  }
  return false;
};

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!isLogged()) {
      next({
        path: "/account/login",
        query: { redirect: to.fullPath }
      });
    } else {
      if (to.matched.some(record => record.meta.adminAuth)) {
        // this route requires admin role, check if isAdmin
        // if not, redirect to login page.
        if (isAuthorizedRole(1)) {
          next();
        } else {
          next({
            path: "/account/login",
            query: { redirect: to.fullPath }
          });
        }
      } else if (to.matched.some(record => record.meta.modAuth)) {
        // this route requires mod role, check if isAdmin or isMod
        // if not, redirect to login page.
        if (isAuthorizedRole(2)) {
          next();
        } else {
          next({
            path: "/account/login",
            query: { redirect: to.fullPath }
          });
        }
      } else if (to.matched.some(record => record.meta.staffAuth)) {
        // this route requires staff role, check if isAdmin or isMod or isStaff
        // if not, redirect to login page.
        if (isAuthorizedRole(3)) {
          next();
        } else {
          next({
            path: "/account/login",
            query: { redirect: to.fullPath }
          });
        }
      }
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js